import React, { useState, useEffect } from "react";
import { NavLink} from "react-router-dom";
import { useLanguage } from "../Components/LanguageContext";
import { useLanguageContent } from "../Components/LangueContentLoader";
import logo from "../Images/LOGO.png";

export default function NavBar() {
  const { selectedLanguage, setSelectedLanguage } = useLanguage();
  const content = useLanguageContent();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", menuOpen);
    return () => document.body.classList.remove("no-scroll");
  }, [menuOpen]);

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
  };

  const handleToggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
        window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    setMenuOpen(false);
  };

  const links = [
    { to: "/", label: content.home },
    { to: "/Projects", label: content.projects },
    { to: "/About", label: content.about },
    { to: "/Skills", label: "Skills" },
    { to: "/Experiences", label: "Experiences" },
    { to: "/Contact", label: content.contact },
  ];

  return (
    <nav className={`navbar ${menuOpen ? "open" : ""}`}>
        <NavLink
        to="/"
        end
        className={({ isActive }) => `logoContainer ${isActive ? "no-active-style" : ""}`}
        onClick={handleLinkClick}
        >
            <img className="logo" src={logo} alt="Logo" />
        </NavLink>

      <button
        className="burger-menu"
        onClick={handleToggleMenu}
        aria-expanded={menuOpen}
        aria-label="Toggle navigation menu"
      >
        <div className="bars-container">
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
      </button>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        {links.map(({ to, label }) => (
          <li key={to}>
            <NavLink to={to} className="link-menu" onClick={handleLinkClick}>
              {label}
            </NavLink>
          </li>
        ))}
        <li>
          <select
            id="language-select"
            value={selectedLanguage}
            onChange={handleLanguageChange}
          >
            <option className="optionsLang" value="en">🇬🇧 Eng</option>
            <option className="optionsLang" value="fr">🇫🇷 Fr</option>
          </select>
        </li>
      </ul>
    </nav>
  );
}
